import { defineStore } from "pinia";
import { ref } from "vue";
import { api } from "@lr-notitia/notitia-operator/client";

export const useBetaStore = defineStore("beta-store", () => {
	let kinasBetaDataspaceId = ref<string>("");

	function getKinasBetaDataspaceId(): Promise<string> {
		return new Promise((resolve, reject) => {
			api()
				.beta()
				.kinasDataspaceId()
				.get()
				.then((id) => {
					kinasBetaDataspaceId.value = id;
					resolve(id);
				})
				.catch((err) => {
					console.error(err);
					reject(err);
				});
		});
	}

	function writeBetaScenarioData(domainId: string, workspaceId: string, presetId: string): void {
		if (!domainId || !workspaceId || !presetId) return;
		api()
			.domain(domainId)
			.workspace(workspaceId)
			.reasoning()
			.post({
				key: "scenarioData",
				value: getScenarioData(presetId),
			});
	}

	function getScenarioData(presetId: string):
		| {
				scenario: number;
		  }
		| undefined {
		presetId = presetId.replace("%20", " ");
		switch (presetId) {
			case "Fall 1":
				return {
					scenario: 1,
				};
			case "Fall 2":
				return {
					scenario: 2,
				};
			case "Fall 3":
				return {
					scenario: 3,
				};
			case "Fall 4":
				return {
					scenario: 4,
				};
			case "Fall 5":
				return {
					scenario: 5,
				};
			case "Fall 6":
				return {
					scenario: 6,
				};
			case "Fall 7":
				return {
					scenario: 7,
				};
		}
		return undefined;
	}

	return {
		getKinasBetaDataspaceId,
		writeBetaScenarioData,
		kinasBetaDataspaceId,
	};
});
